import React from 'react';
import Pagamento from './Pagamento';
import './PagamentoKiosk.css';

const PagamentoKiosk = () => {
  // O KioskGuard já verificou a autenticação, então podemos usar um usuário básico
  // ou buscar informações do usuário se necessário
  const kioskUser = {
    name: 'Modo Kiosk',
    accountType: 'kiosk',
    isKiosk: true // Flag para identificar modo kiosk
  };

  return (
    <div className="pagamento-kiosk">
      <Pagamento user={kioskUser} />
    </div>
  );
};

export default PagamentoKiosk;